module.exports = __webpack_public_path__ + "static/media/Annual-leave-icon.57fd3b1b.svg";